var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { Button, Form, FormGroup, FormFeedback, Label, Input, InputGroup, InputGroupAddon, InputGroupText, CustomInput, Modal, ModalHeader, ModalBody, ModalFooter, Popover, PopoverHeader, PopoverBody } from 'reactstrap';
import { Card, CardTitle, CardText, CardBody, Row, Col, Container } from 'reactstrap';

import TagsInput from 'react-tagsinput';
import 'react-tagsinput/react-tagsinput.css';

var logdown = require('logdown');
var console = logdown('rx-forms-rx-tags', { prefixColor: '#00897b' });

var RXTags = function (_Component) {
    _inherits(RXTags, _Component);

    function RXTags(props) {
        _classCallCheck(this, RXTags);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.onChange = function (data) {

            _this.setState({ value: data }, function () {
                _this.props.onChange({ target: { value: _this.state.value, id: _this.props.name } });
            });
        };

        _this.pasteSplit = function (data) {
            console.log('in paste split');
            return data.split(",");
        };

        console.log('13000: ', _this.props);

        var value = _this.props.value && _this.props.value != "" ? _this.props.value : [];
        console.log('13001: value: ', value);
        _this.state = {
            invalid: false,
            value: value
        };

        return _this;
    }

    RXTags.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {

        if (this.props.value != prevProps.value) {
            this.setState({ value: this.props.value });
        }
    };

    RXTags.prototype.render = function render() {
        var _this2 = this;

        var _props = _extends({}, this.props),
            props = _props.props,
            value = _props.value;

        return React.createElement(
            React.Fragment,
            null,
            React.createElement(TagsInput, _extends({
                ref: function ref(_ref) {
                    return _this2.tagsInput = _ref;
                },
                value: this.state.value,
                onChange: this.onChange

                // inputValue={this.state.tag}
                // onChangeInput={this.handleInputChange}
                , pasteSplit: this.pasteSplit,
                addKeys: [188, 9, 13] /* 188 is a comma, 9 is tab, 13 is enter */
                , addOnPaste: true,
                onlyUnique: true
            }, props)),
            this.state.invalid && React.createElement(
                'div',
                { className: 'text-danger small' },
                this.props.feedbackMessage
            )
        );
    };

    return RXTags;
}(Component);

export default RXTags;